import React from 'react';
import {
  Flame, Sun, UtensilsCrossed, IceCream2 as Cake, Coffee, Leaf, Soup, Salad, Pizza, Camera
} from 'lucide-react';

// Category → Lucide icon mapping (shared across components)
export const categoryIcons = {
  main_dish: { Icon: Flame, label: 'Main Dish' },
  appetizer: { Icon: Pizza, label: 'Appetizer' },
  dessert: { Icon: Cake, label: 'Dessert' },
  salad: { Icon: Salad, label: 'Salad' },
  soup: { Icon: Soup, label: 'Soup' },
  side: { Icon: Leaf, label: 'Side Dish' },
  breakfast: { Icon: Sun, label: 'Breakfast' },
  snack: { Icon: Pizza, label: 'Appetizer' },
  beverage: { Icon: Coffee, label: 'Beverage' },
  other: { Icon: UtensilsCrossed, label: 'Recipe' }
};

const RecipePlaceholder = ({ category = 'other', size = 'medium', className = '', onAddPhoto }) => {
  const config = categoryIcons[category] || categoryIcons.other;
  const { Icon } = config;

  const sizeConfig = {
    small: { container: 'h-24', icon: 24 },
    medium: { container: 'h-40', icon: 40 },
    large: { container: 'h-56', icon: 56 }
  };
  const s = sizeConfig[size];

  return (
    <div
      className={`w-full ${s.container} bg-gray-100 rounded-xl flex flex-col items-center justify-center relative overflow-hidden ${className}`}
    >
      <Icon size={s.icon} className="text-gray-500" strokeWidth={1.5} />
      <span className="mt-2 text-gray-500 text-sm font-medium">{config.label}</span>
      {onAddPhoto ? (
        <button
          onClick={onAddPhoto}
          className="mt-2 text-gray-500 text-xs bg-white/70 hover:bg-white px-3 py-1 rounded-full transition-colors flex items-center gap-1.5 border border-gray-200"
        >
          <Camera size={12} /> Add your photo!
        </button>
      ) : (
        <span className="mt-1 text-gray-400 text-xs flex items-center gap-1">
          <Camera size={11} /> Add your photo!
        </span>
      )}
    </div>
  );
};

// Card-sized placeholder (for grid cards)
export const RecipePlaceholderCard = ({ category = 'other' }) => {
  const config = categoryIcons[category] || categoryIcons.other;
  const { Icon } = config;

  return (
    <div className="w-full h-32 bg-gray-100 rounded-t-xl flex items-center justify-center">
      <Icon size={36} className="text-gray-400" strokeWidth={1.5} />
    </div>
  );
};

// Inline thumbnail placeholder (for list items / buzz cards)
export const CategoryIconThumb = ({ category = 'other', size = 20 }) => {
  const config = categoryIcons[category] || categoryIcons.other;
  const { Icon } = config;
  return <Icon size={size} className="text-gray-500" strokeWidth={1.5} />;
};

export default RecipePlaceholder;
